import "../../_generated_templates.js";
window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.Question = class Question extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.getResponseTypeIconName = this.getResponseTypeIconName.bind(this);
  }

  initialize() {
    this.listenTo(this.model, "change:title", this.render);
    this.listenTo(this.model, "change:responseType", this.render);
    return this.listenTo(this.model, "change:position", this.render);
  }

  render() {
    const context = this.contextForRender();
    this.$el.html(this.template(context));
    return this;
  }

  contextForRender() {
    const context = Object.assign({}, this.model.attributes);
    context.responseTypeIconName = this.getResponseTypeIconName();
    return context;
  }

  triggerQuestionClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.Question.clicked, [this.model]);
  }

  triggerRemoveQuestionClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.Question.removeClicked, [this.model]);
  }

  getResponseTypeIconName() {
    switch (this.model.get("responseType")) {
      case "select_one":
        return "form-radio-buttons";
      case "select_multiple":
        return "form-select";
      case "free_text":
        return "form-textarea";
    }
  }
};
AssessmentBuilder.Views.Question.prototype.tagName = "question-element";
AssessmentBuilder.Views.Question.prototype.template = _.template(AssessmentBuilder.Templates.Question.question);

AssessmentBuilder.Views.Question.prototype.events = {
  click: "triggerQuestionClicked",
  "click remove-question-button": "triggerRemoveQuestionClicked",
};
